import { Currency, Paginated, ServerSideCurrency } from './types'
import { getAffiliateInstance } from '../utils/axios'
import { mapServerSideCurrency } from '../utils/api.mapper'



export const fetchCurrency = async (): Promise<Paginated<Currency>> => {
  const { data, headers } = await getAffiliateInstance().get<ServerSideCurrency[]>('api/currencies')

  return {
    page: Number(headers['x-pagination-page']),
    pages: Number(headers['x-pagination-pages']),
    items: data.map(mapServerSideCurrency),
  }
}
